import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { UserSubscriptionType } from '../../services/subscriptions/subscriptions.types';
import { type RoomForPatient } from '../../services';

const getInitialState = (): RoomForPatient => ({
  id: '0',
  legacyId: 0,
  name: '',
  isPersonal: false,
  displayName: '',
  slug: '',
  roomAdmin: {
    id: '0',
    title: '',
    firstName: '',
    lastName: '',
    displayName: '',
    userProfilePictureUrl: '',
    subscriptionType: UserSubscriptionType.Free,
  },
  usePasscode: false,
  shouldRedirect: false,
  redirectUrl: '',
  usePasscodeStoredValue: false,
});

export const waitingRoomSlice = createSlice({
  name: 'waitingRoom',
  initialState: getInitialState(),
  reducers: {
    setWaitingRoom: (state, action: PayloadAction<RoomForPatient | null>) => {
      return { ...state, ...action.payload };
    },
  },
});

export const { setWaitingRoom } = waitingRoomSlice.actions;
